<template>
  <div class="select_and_drag">
    <div class="available_cols">
      <div class="cols_inner">
        <h3 v-translate>Dostupné položky</h3>
        <search-input v-model="search" v-if="allowSearch"></search-input>
        <ul>
          <li v-for="item in filteredItems">
              <input type="checkbox"
                     :id="name+'_'+item.id"
                     :name="name+'_'+item.id"
                     @change="onSelectChange($event.target.checked, item.id)"
                     :checked="isChecked(item.id)"
                     :disabled="disabled || !allowSelecting"
              >
              <label :for="name+'_'+item.id">
                {{item.name}}
                <channel-video-quality-label v-if="isChannelList" :quality="item.video_quality" />
              </label>
          </li>
        </ul>
      </div>
    </div>

    <div class="selected_cols">
      <div class="cols_inner">
        <h3><template>{{$gettext("Vybrané položky")}}</template> <span class="col_number">({{selectedCount}})</span></h3>
        <ul id="sortable_part">
          <li v-for="key in existingValues" :itemId="key" :style="sortingStyle" :key="key">{{selectedItemName(key, itemsById[key].name)}}
            <channel-video-quality-label v-if="isChannelList" :quality="itemsById[key].video_quality" />
            <a v-if="!disabled && allowSelecting" class="remove_col" @click="onSelectChange(false, key)" :title="'Odebrat' | translate" v-translate>Odebrat</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

import channelVideoQualityLabel from "./ChannelVideoQualityLabel.vue";
import {removeAccents} from "../../utils/helpers";

export default {
  name: "SortableCheckboxList",
  components: {channelVideoQualityLabel},
  props: {
    items: {},
    value: [],
    disabled: false,
    name: String,
    isChannelList: Boolean,
    allowSorting: {
      type: Boolean,
      default: true,
    },
    allowSelecting: {
      type: Boolean,
      default: true,
    },
    allowSearch: {
      type: Boolean,
      default: true
    },
    showId: {
      type: Boolean,
      default: true,
    },
    reload: Function,
  },
  data(){
    return {
      search: "",
      content: this.value,
    }
  },
  mounted() {
    $('#sortable_part').sortable({
      stop: this.onSortingChange
    });
    this.reloadSorting(this.isSortingAllowed);
  },
  computed: {
    selectedCount(){
      return this.existingValues.length;
    },
    isSortingAllowed(){
      let allow = !this.disabled && this.allowSorting;
      this.reloadSorting(allow);
      return allow;
    },
    sortingStyle(){
      if(this.isSortingAllowed){
        return {};
      }else{
        return {
          background: 'none !important',
          cursor: 'default'
        }
      }
    },
    filteredItems(){
      if(this.search.length){
        return this.items.filter((item) => {
          let a = removeAccents(item.name).toLowerCase();
          let b = removeAccents(this.search).toLowerCase();
          return a.includes(b)
        });
      }else {
        return this.items;
      }
    },
    itemsById(){
      let itemsById = {};
      this.items.forEach((item) => {
        itemsById[item.id] = item;
      });
      return itemsById;
    },
    existingValues(){
      return this.content.filter((id) => this.itemsById.hasOwnProperty(id));
    }
  },
  methods: {
    selectedItemName(key, name){
      if(this.showId){
        return key +" "+ name;
      }else{
        return name;
      }
    },
    reloadSorting(isSortingAllowed){
      if(isSortingAllowed){
        $('#sortable_part').sortable('enable');
      }else{
        $('#sortable_part').sortable('disable');
      }
    },
    isChecked(id){
      return this.content.includes(id);
    },
    onSelectChange(checked, id){
      if(checked){
        this.content.push(id);
      }else{
        this.content.splice(this.content.indexOf(id), 1);
      }
      this.onChange();
    },
    onSortingChange() {
      let order = ($('#sortable_part li').map(function () {
        return $(this).attr('itemId');
      }).get());
      this.content = order;
      this.onChange();
    },
    onChange(){
      this.$emit('input', this.content);
    },
  },
  watch:{
    value(){
      this.content = this.value;
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/SortableCheckboxList.vue